import { toast } from "react-toastify";

export const CLIENT_USER_TOAST_OPTIONS = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const showClientUserToast = {
  success: (message) => toast.success(message, CLIENT_USER_TOAST_OPTIONS),
  error: (message) => toast.error(message, CLIENT_USER_TOAST_OPTIONS),
};

export const pushWithClientUserNotify = (history, path, message, type = "success") => {
  history.push(path, {
    clientUserNotify: {
      type,
      message,
    },
  });
};

export const showClientUserRouteNotify = (history, location) => {
  const notify = location.state && location.state.clientUserNotify;
  if (!notify || !notify.message) {
    return;
  }

  if (notify.type === "error") {
    showClientUserToast.error(notify.message);
  } else {
    showClientUserToast.success(notify.message);
  }

  history.replace({
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  });
};
